module.exports = __webpack_public_path__ + "img/to-your-head_682x734.ba71dced.jpg";